import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import { Carousel } from "react-bootstrap";
import client1 from "../../Assets/client1.png";
import client2 from "../../Assets/client2.png";
import client3 from "../../Assets/client3.png";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a Software Engineer Student who loves transforming ideas into
              reliable, scalable products. Over time, I’ve explored several
              technologies and found my passion in building high-performance
              systems and intuitive user experiences.
              <br />
              <br />
              I’m proficient in
              <i>
                <b className="purple">
                  {" "}
                  JavaScript, R, Python, Node.js and Java{" "}
                </b>
              </i>
              — and I enjoy working across both backend and frontend stacks.
              <br />
              <br />
              My key areas of interest include developing
              <i>
                <b className="purple">
                  {" "}
                  DBA and Agile Methods,{" "}
                </b>
              </i>
              and exploring new ways to bridge on-chain and off-chain systems.
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> Typescript </b>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>
              SATISFIED <span className="purple">CLIENTS</span>
            </h1>
            <p>
              See what people are saying about my work.
            </p>
            <Carousel className="testimonial-carousel">
              <Carousel.Item>
                <img
                  className="d-block mx-auto testimonial-img"
                  src={client1}
                  alt="Client 1"
                />
                <Carousel.Caption>
                  <h3>Jane Doe</h3>
                  <p>"Ricardo delivered exceptional results on time and within budget!"</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block mx-auto testimonial-img"
                  src={client2}
                  alt="Client 2"
                />
                <Carousel.Caption>
                  <h3>J. James Johnson</h3>
                  <p>"Very good, he helped me to catch spiderman!."</p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block mx-auto testimonial-img"
                  src={client3}
                  alt="Client 3"
                />
                <Carousel.Caption>
                  <h3>Oscar Niemeyer</h3>
                  <p>"A highly skilled developer who truly understands client needs."</p>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
